import styled from 'styled-components';
import React, { FC, ReactNode } from 'react';

export interface CodeSnippetLayoutProps {
  header: ReactNode;
}

const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const CodeSnippetLayout: FC<React.PropsWithChildren<CodeSnippetLayoutProps>> = ({ header, children, ...rest }) => (
  <Root {...rest}>
    {header}
    {children}
  </Root>
);
